import { Alert } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import type { MatrixColumn } from './types.js';

/** The pull failures, named above the grid — the cells under them only dim to Unknown. */
export const PullFailedAlert = ({ columns }: { columns: MatrixColumn[] }) => {
    const failed = columns.filter((column) => column.pullFailed);
    if (failed.length === 0) return null;
    return (
        <Alert
            color="red"
            icon={<IconAlertTriangle size={16} stroke={1.7} />}
            title="Some environments could not be pulled"
        >
            {failed.map((column) => `${column.name}: ${column.pullError}`).join(' · ')}
        </Alert>
    );
};
